export default __webpack_public_path__ + "static/media/ballons.36ca6d82.jpg";